import {Config, Auth} from 'olympe';

/**
 *
 */
class UserController {
    /**
     * @param {string=} devUser
     * @return {string}
     */
    getCurrentUserName(devUser) {
        let currentUserId;
        switch (Config.getParameter('ENV')) {
        case 'preprod':
        case 'prod':
            currentUserId = localStorage.getItem('Current_Sap_User') || 'JDUBEY';
            break;
        case 'codev':
            currentUserId = devUser ?? 'EZPR-USER';
            break;
        default:
            currentUserId = 'JDUBEY';
            break;
        }
        return currentUserId;
    }
}

// singleton
export default new UserController();
